import { Injectable } from '@angular/core';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';
import { BehaviorSubject } from 'rxjs';

export interface PageHeaderData {
  title: string;
  subtitle?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PageHeaderService {
  headerText$ = new BehaviorSubject<string>(Defaults.stringEmpty);
  headerData$ = new BehaviorSubject<PageHeaderData>({ title: Defaults.stringEmpty });

  setHeaderText(headerText: string): void {
    this.headerText$.next(headerText);
    this.headerData$.next({ title: headerText });
  }

  setHeaderData(data: PageHeaderData): void {
    this.headerText$.next(data.title);
    this.headerData$.next(data);
  }
}